import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {Router, ActivatedRoute} from "@angular/router";
import {Observable} from "rxjs";
import {GlobalService} from '../global/global.service';
declare const drift;
@Component({
  selector: 'app-schema',
  templateUrl: './schema.component.html',
  styleUrls: ['./schema.component.scss']
})
export class SchemaComponent implements OnInit {
  @ViewChild('searchKey') searchElement: ElementRef;

  constructor(public router: Router,
             private route: ActivatedRoute) {

  }

  ngOnInit() {
    const name: Observable<string> = this.route.params.map(p => p.name);
    this.route.params.subscribe(params => {
      const term = params['name'];
      // term ? '': this.searchElement.nativeElement.value = '';

    });
  }


  navigate() {
    this.router.navigate(['/schema/new']);
  }

  search(value) {
    this.router.navigate(['.', { 'name': value}]);
  }


}



// WEBPACK FOOTER //
// ./src/app/schema/schema.component.ts